
import {QuoteEntryRequestModel} from './quote-entry-request-model';
export class QuoteEditModel {
    buyerID: string = null;
    quoteEntryRequest ?= new QuoteEntryRequestModel ();
    quoteTemplate?: any = null;
    remark ?: string = null ;
    validity: string = null;
    quoteCode: any = null;
    quoteAction: any = null;
}
